/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import {Col} from 'reactstrap';

/** Multiple Language imports **/
import {withLocalize} from "react-localize-redux";
import {renderToStaticMarkup} from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import {Translate} from "react-localize-redux";
import global from "../translations/global.json"
/** End of Multiple Language imports **/

import LanguageManager from '../custom-classes/language-manager';
import NavbarMobile from './navbar/navbar-mobile';
import FormProfileRegister from './forms/form-profile-register';
import { Redirect } from 'react-router-dom'

/**
 * The form to register new users
 */
class ProfileRegister extends React.Component {

    constructor(props) { // start with a constructor if we want to do modifications on events
        super(props); // Super is required.

        // Declare the properties and set the value according to what we are going to manage in the the page
        this.state = {
           subscriptionId: '',
            cameFromRegister: false,
            goToDashboard: false
        };

        // To support language library add the following lines
        this.props.initialize({
            languages: [
                {name: "English", code: "en"},
                {name: "Español", code: "es"}
            ],
            options: {renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage("en")}
        });
        this.props.addTranslation(global)
        this.setGoNext = this.setGoNext.bind(this);
    }

    /**
     * Sets where to go next 
     * @param data
     */
    setGoNext(data){
       this.setState({goToDashboard: data.goToDashboard});
    }

    /**
     * Renders the main form element
     * @returns {XML}
     */
    render() {
        if(this.state.goToDashboard)
            return (<Redirect to={{pathname: '/dashboard'}}/>);
        else
            return( <div>
                <NavbarMobile/>
                <Col sm={{size: 8, offset: 2}} lg={{size: 6, offset: 3}}>
                    <FormProfileRegister data={this.state} updateParent={this.setGoNext}/>
                </Col>
            </div>);
    }
}

export default withLocalize(ProfileRegister);


// WEBPACK FOOTER //
// ./src/components/profile-register.js